module.exports = __webpack_public_path__ + "media/images/autopilot/robot-cp-354fd019713a7ac496749e390e35e34d.svg";